import React from 'react';
import { useQuery } from 'react-query';
import api from '../../../components/api';

export interface VendingMachineData {
  'removed': string;
  'clientName': string;
  'model': any;
  'deviceId': string;
  'nickName': null;
  'location': string;
  'id': string;
  'type': string;
}

export interface VendingMachineListType {
  'clientName': string;
  'vendingMachines': VendingMachineData[]
}

function useVendingMachine() {
  /*
  * Because this react element are used for 2 page router that are coffee and vending machine,
  * We need to check from url, is it coffee page or not
  * */
  const isCoffee: boolean = React.useMemo(
    () => window.location.pathname.split('/')[1] === 'coffee-machine',
    [window.location.pathname],
  );

  const isWholesale: boolean = React.useMemo(
    () => window.location.pathname.split('/')[1] === 'wholesale',
    [window.location.pathname],
  );

  /*
  *
  *
  *
  *
  *
  * Handling for filter data :
  * 1. Filter by page
  * 2. Filter by Search Value - Currently not used cause still waiting for API
  * 3. Filter by Initial Alphabet
  * */

  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const [searchValue, setSearchValue] = React.useState<string>('');
  const [currentInitial, setCurrentInitial] = React.useState<string>('ALL');

  // Fetching Data from Database
  // 1. Client when filter by alphabet is All
  const { data: clientRes, isLoading: clientLoading, refetch: clientRefetch } = useQuery(
    ['getAllActive', 'clients', currentPage - 1, 10],
    () => api.clients.getActives(currentPage - 1, 10),
    { enabled: currentInitial === 'ALL' },
  );
  // 3. Client when filter by alphabet
  const { data: clientByInitialRes, isLoading: clientByInitialLoading, refetch: byInitialRefetch } = useQuery(
    ['getByInitial', 'clients', currentInitial, currentPage - 1, 10],
    () => api.clients.getByInitial(currentInitial, currentPage - 1, 10),
    { enabled: currentInitial !== 'ALL' },
  );

  // Data list and total page management
  const vmList = React.useMemo(() => {
    let clientData = clientByInitialRes?.data;
    if (currentInitial === 'ALL') clientData = clientRes?.data;
    const list = clientData?.data?.map((x) => ({
      ...x,
      vendingMachines: x.vendingMachines?.filter((vmClient) => (((isCoffee && vmClient?.type === 4) || (isWholesale && vmClient?.type === 5) || ((!isCoffee && !isWholesale) && vmClient?.type !== 4 && vmClient?.type !== 5)) && !vmClient?.removed)),
    }));
    return {
      list, totalPage: clientData?.totalPages ?? 1,
    };
  }, [clientRes, clientByInitialRes, currentInitial, isCoffee, isWholesale]);

  // Refetch Handler
  const handleRefetch = () => {
    const refetchCatcher = (e: any) => {
      console.log(e);
      window.location.reload();
    };
    if (currentInitial === 'ALL') clientRefetch().catch((e) => refetchCatcher(e));
    else byInitialRefetch().catch((e) => refetchCatcher(e));
  };

  return {
    isCoffee,
    isWholesale,
    searchValue,
    setSearchValue,
    vm: {
      list: vmList.list,
      totalPage: vmList.totalPage,
      load: clientLoading || clientByInitialLoading,
      refetch: handleRefetch,
    },
    initial: {
      current: currentInitial,
      setCurrent: setCurrentInitial,
    },
    page: {
      current: currentPage,
      setCurrent: setCurrentPage,
    },
  };
}

export default useVendingMachine;
